import type { BaseColours } from "@qendo/theme";

const base: BaseColours = {
    transparent: "transparent",
    current: "currentColor",
    white: "#FFFFFF",
    black: "#000000",
    navy: {
        0: "#D1E3F600",
        50: "#D1E3F67F",
        100: "#D1E3F6",
        200: "#A6C6EE",
        300: "#7096CD",
        400: "#43649B",
        500: "#162D59",
        600: "#10224C",
        700: "#0B1940",
        800: "#071133",
        900: "#040C2A",
    },
    "navy-inverse": {
        0: "#040C2A00",
        100: "#040C2A",
        200: "#071133",
        300: "#0B1940",
        400: "#10224C",
        500: "#162D59",
        600: "#43649B",
        700: "#7096CD",
        800: "#A6C6EE",
        900: "#D1E3F6",
    },
    pink: {
        0: "#E9C5C533",
        100: "#FDF8F6",
        200: "#FCF1ED",
        300: "#F8E5E1",
        400: "#F1D8D5",
        500: "#E9C5C5",
        600: "#C89094",
        700: "#A7636F",
        800: "#873E51",
        900: "#6F253F",
        950: "#4D1529",
    },
    "pink-inverse": {
        0: "#4D152900",
        100: "#4D1529",
        200: "#6F253F",
        300: "#873E51",
        400: "#A7636F",
        500: "#C89094",
        600: "#E9C5C5",
        700: "#F1D8D5",
        800: "#F8E5E1",
        900: "#FCF1ED",
        950: "#FDF8F6",
    },
    green: {
        0: "#D0F5E100",
        50: "#D0F5E17F",
        100: "#D0F5E1",
        200: "#A2ECC2",
        300: "#73E2A4",
        400: "#45D985",
        500: "#27BE69",
        600: "#1F9854",
        700: "#17723F",
        800: "#104C2A",
        900: "#0C351E",
        950: "#031109",
    },
    blue: {
        0: "#E2E7FF00",
        25: "#F1F3FF",
        50: "#E2E7FF7F",
        100: "#E2E7FF",
        200: "#CBD6FF",
        300: "#91A3FF",
        400: "#708DFF",
        500: "#4C6FFF",
        600: "#2A55F0",
        700: "#2345D8",
        800: "#1C34A0",
        900: "#141E66",
        950: "#0D123F",
    },
    yellow: {
        0: "#FFF3D100",
        50: "#FFF3D17F",
        100: "#FFF3D1",
        200: "#FFE59E",
        300: "#FFD970",
        400: "#FFCB3D",
        500: "#FFBF0F",
        600: "#D69D00",
        700: "#A37800",
        800: "#654B01",
        900: "#3D2D01",
    },
    red: {
        25: "#F1F3FF",
        100: "#FCD9DE",
        200: "#FABFC7",
        300: "#F896A4",
        400: "#F5647F",
        500: "#E5102E",
        600: "#B51A25",
        700: "#8C131C",
        800: "#5C0B14",
        900: "#440810",
    },
    slate: {
        50: "#FBFAF97F",
        100: "#F7F8F9",
        200: "#F1F2F4",
        300: "#E8E9EC",
        400: "#D6D8DB",
        500: "#B8BABD",
        600: "#888A8D",
        700: "#5D5F62",
        800: "#212327",
        900: "#0B0D10",
    },
};

export default base;
